"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var CreditCard = function CreditCard(_a) {
  var fill = _a.fill,
      props = __rest(_a, ["fill"]);

  return react_1.default.createElement(Svg_1.default, __assign({}, props, {
    viewBox: "0 0 30.571 19"
  }), react_1.default.createElement("g", {
    transform: "translate(-1395 -323)"
  }, react_1.default.createElement("g", {
    transform: "translate(1170.286 318.714)"
  }, react_1.default.createElement("g", {
    transform: "translate(226.714 4.286)"
  }, react_1.default.createElement("path", {
    fill: "#0072be",
    d: "M232.2,20.286h-5.487V7.714c0-1.893,2.221-3.428,4.115-3.428h4.115V16.857C234.943,18.751,234.094,20.286,232.2,20.286Z",
    transform: "translate(-226.714 -4.286)"
  }), react_1.default.createElement("path", {
    fill: "#ff151f",
    d: "M239.4,20.286h-5.487V7.714c0-1.893,2.221-3.428,4.115-3.428h4.115V16.857C242.143,18.751,241.294,20.286,239.4,20.286Z",
    transform: "translate(-224.314 -4.286)"
  }), react_1.default.createElement("path", {
    fill: "#00a649",
    d: "M246.6,20.286h-5.487V7.714c0-1.893,2.221-3.428,4.115-3.428h4.115V16.857C249.343,18.751,248.494,20.286,246.6,20.286Z",
    transform: "translate(-221.914 -4.286)"
  }))), react_1.default.createElement("rect", {
    fill: "none",
    width: "32",
    height: "16",
    transform: "translate(1395 323)"
  })));
};

CreditCard.displayName = 'CreditCard';
exports.default = CreditCard;